import React from "react";
import defaultThaliImg from "../assets/AnadaanThali.webp";

const AnnaDaan = ({
  donations = [],
  toggleDonation,
  title = "AnnaDaan Seva",
  mealsOptions = [
    { meals: 10, price: 501 },
    { meals: 20, price: 1000 },
    { meals: 40, price: 2000 },
    { meals: 100, price: 5000 },
    { meals: 200, price: 10000 },
    { meals: 400, price: 20000 },
    { meals: 1000, price: 50000 },
    { meals: 2000, price: 100000 },
    { meals: 10000, price: 500000 },
  ],
  image = defaultThaliImg,
}) => {
  return (
    <div className="md:px-12 px-6 lg:px-8 py-6 sm:py-8">
      <h2 className="text-center text-red text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 pb-1">
        {title}
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        {mealsOptions.map(({ meals, price }) => {
          const label = `Donate ${meals.toLocaleString()} Meals`;
          const added = donations.some((d) => d.label === label);
          return (
            <div
              key={meals}
              className="bg-gray-100 border border-rose-700 rounded-lg p-3 sm:p-4 flex items-center justify-between gap-2"
            >
              <div className="flex items-center gap-3">
                <img
                  src={image}
                  alt="thali"
                  className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg object-cover flex-shrink-0"
                />
                <div>
                  <p className="text-black font-semibold text-xs sm:text-sm">
                    {label}
                  </p>
                  <p className="text-black text-xs sm:text-sm mt-1">
                    ₹{price.toLocaleString()}
                  </p>
                </div>
              </div>
              <button
                onClick={() => toggleDonation(label, price, image)}
                className={`text-xs sm:text-sm px-2 sm:px-4 py-2 rounded transition-colors whitespace-nowrap flex-shrink-0 ${
                  added
                    ? "bg-gray-400 text-white hover:bg-gray-500"
                    : "bg-red text-white hover:bg-darkred"
                }`}
              >
                {added ? "Remove" : "Add Donation"}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AnnaDaan;
